import DateInputRange from './DateInputRange'

export default DateInputRange
